import { useStore } from '../store/StoreContext.jsx';

// A control that only changes what is SHOWN — open a row's note, unfold a
// row's details, expand the notes panel, collapse a rail — and never the
// record.
//
// View mode locks the form by wrapping it in a disabled <fieldset> (App.jsx),
// and the browser disables every real <button> inside one with no way to opt a
// single button back in. That is exactly right for Add, Remove and the spouse
// toggle, and exactly wrong for these: a planner opening a household to READ
// it could see the note icon lit on a row and not open it, and could not
// expand the notes panel at all (Jimmy, 2026-09-18). The notes were the thing
// they came to read.
//
// So in view mode this renders a focusable role="button" element instead,
// which a disabled fieldset leaves alone. Outside view mode it is an ordinary
// <button> and nothing about the form changes. Use it ONLY for controls that
// cannot alter the record; the e2e suite still asserts that every real
// <button> inside the lock is disabled, so a mutating control added later
// stays locked by default rather than by remembering.
export default function ViewButton({ onClick, className = '', children, ...rest }) {
  const { readOnly } = useStore();
  if (!readOnly) {
    return (
      <button type="button" className={className} onClick={onClick} {...rest}>
        {children}
      </button>
    );
  }
  return (
    <span
      role="button"
      tabIndex={0}
      className={`${className} view-btn`.trim()}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.(e);
        }
      }}
      {...rest}
    >
      {children}
    </span>
  );
}
